import { render, staticRenderFns } from "./TaskStatusButton.vue?vue&type=template&id=0f77989c&"
import script from "./TaskStatusButton.vue?vue&type=script&lang=ts&"
export * from "./TaskStatusButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports